/**
 * Transforms the product detail request payload from the domain to the request options
 *
 */
export function productDetailPresenter(payload: { sku: string; cycle: number; isPdp?: boolean }) {
  const { sku, cycle, isPdp } = payload;

  return {
    sku,
    cycle,
    isPdp,
  };
}
